import { render, staticRenderFns } from "./AddNewTypedSurvey.vue?vue&type=template&id=b62cba1e&scoped=true"
import script from "./AddNewTypedSurvey.vue?vue&type=script&lang=js"
export * from "./AddNewTypedSurvey.vue?vue&type=script&lang=js"
import style0 from "./AddNewTypedSurvey.vue?vue&type=style&index=0&id=b62cba1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62cba1e",
  null
  
)

export default component.exports